import { type ReactNode, useState } from 'react'
import { Icon, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type ILocalCollapseProps = {
  credits: string
  title: string
  content: ReactNode
}

export const TooltipCollapse = ({ credits, title, content }: ILocalCollapseProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => {
    setIsOpen((prev) => !prev)
  }

  return (
    <div>
      <Typography
        ariaLabel='credits_type'
        variant='body-md-regular'
        color='var(--content-primary-primary-inverted)'
        marginBottom={3}
        tag='div'
      >
        {credits} credits
      </Typography>
      <div className={styles.tooltipHeader} onClick={handleToggle}>
        <Typography
          ariaLabel='collapse_title'
          variant='text-input-helper'
          color='var(--content-primary-disabled-inverted)'
        >
          {title}
        </Typography>
        <Icon
          icon={isOpen ? 'chevronUp' : 'chevronDown'}
          fontSize={16}
          color='var(--content-primary-tertiary-inverted)'
        />
      </div>
      {isOpen && (
        <div className={styles.tooltipContent}>
          <Typography
            ariaLabel='tooltip_content'
            variant='body-sm-regular'
            color='var(--content-primary-tertiary-inverted)'
          >
            {content}
          </Typography>
        </div>
      )}
    </div>
  )
}
